import wsNoProcTemplate from './wsNoProc.html';

/*******************************************************************************
 * @ngdoc   component
 * @mdule   csm.ui.webStore
 * @name    csm.ui.webStore.component:wsNoProc
 *
 * @description
 * This component displays a warning when the organinzation does not have any
 * processors set up for the web store and provides a button that will take the
 * user to the Our Org app to set up a payment processor.
 *******************************************************************************/
export const wsNoProcComponent ={
  template: wsNoProcTemplate,
  controller: WsNoProcController
}

/* @ngInject */ function WsNoProcController(AppConfig, MenuService) {
  var $ctrl = this;
  MenuService.findOption(AppConfig.ourOrgMenuOptionName).then((ourOrg) =>
    Object.assign($ctrl, {
      ourOrgOption: ourOrg.option,
      procMessage: `A Webstore Payment Processor must be added in "${ourOrg.option}" before continuing.`,
      redirect: () => MenuService.displayApp(ourOrg)
    })
  );
}
